import * as React from "react";
import { forwardRef } from "react";
const SvgIconAreaShrink = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 17, fill: "none", viewBox: "0 0 17 17", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 5V0H5v5H0v2h5a2 2 0 0 0 2-2Zm5 5a2 2 0 0 0-2 2v5h2v-5h5v-2h-5Zm0-6.4V0h-2v5c0 1.2.8 2 2 2h5V5h-3.6l3.3-3.3L15.3.3l-3.4 3.3ZM0 10h5a2 2 0 0 1 2 2V17H5v-3.6l-3.3 3.3-1.4-1.4 3.3-3.4H0v-2Z", fill: "#fff" }));
const ForwardRef = forwardRef(SvgIconAreaShrink);
export default ForwardRef;
